import { render, staticRenderFns } from "./SizeChartType.vue?vue&type=template&id=750c2878&"
import script from "./SizeChartType.vue?vue&type=script&lang=js&"
export * from "./SizeChartType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports